import { reactive } from 'vue';

export const sharedState = reactive({
  themeMode: localStorage.getItem('themeMode') || '0'
});
